<div class="form-settings-row">
  <div class="form-title-section">
    @if (formTypeIcon()) {
      <span class="form-type-icon material-symbols-outlined" [title]="formType()">{{ formTypeIcon() }}</span>
    }
    <label class="form-label">Title</label>
    <div class="divider-vertical"></div>
    <input
      type="text"
      class="form-title-input"
      placeholder="Enter a title for your form"
      [value]="formTitle()"
      [disabled]="isReadOnly()"
      (input)="onTitleChange($event)">
  </div>
  <div class="form-description-section">
    <label class="form-label">Description</label>
    <div class="divider-vertical"></div>
    <input
      type="text"
      class="form-title-input"
      placeholder="Enter a description for your form"
      [value]="formDescription()"
      [disabled]="isReadOnly()"
      (input)="onDescriptionChange($event)">
  </div>
  <div class="form-version-section">
    <label class="form-label">Version</label>
    <div class="divider-vertical"></div>
    <input
      type="number"
      class="form-title-input version-input"
      placeholder="0"
      [value]="formVersion()"
      [disabled]="isReadOnly()"
      (input)="onVersionChange($event)"
      min="0">
  </div>
  <!-- Type and status in one chip: two facts about the same form. -->
  <div class="form-badge"
    [class.draft]="formStatus() === FormStatus.Draft"
    [class.published]="formStatus() === FormStatus.Published"
    [class.archived]="formStatus() === FormStatus.Archived"
    [title]="(formTypeLabel() ? formTypeLabel() + ' · ' : '') + statusLabel()">
    @if (formTypeLabel()) {
      @if (formTypeIcon()) {
        <span class="material-symbols-outlined badge-type-icon">{{ formTypeIcon() }}</span>
      }
      <span class="badge-type">{{ formTypeLabel() }}</span>
      <span class="badge-divider"></span>
    }
    <span class="badge-status-dot"></span>
    <span class="badge-status">{{ statusLabel() }}</span>
  </div>
  @if (promotionLabel(); as label) {
    <div class="promotion-chip"
      [class.requested]="promotionState() === 'Requested'"
      [class.approved]="promotionState() === 'Approved'"
      [class.promoted]="promotionState() === 'Promoted'"
      [class.failed]="promotionState() === 'Failed'"
      [title]="promotionDetail()">
      <i [class]="promotionIcon()"></i>
      <span>{{ label }}</span>
    </div>
  }
  <!-- Anything a particular form type adds to the bar, e.g. assessment matrices. -->
  <ng-content select="[formHeaderExtras]"></ng-content>
</div>

